import(/* webpackMode: "eager" */ "/codebuild/output/src560617999/src/smart-consumption-web/src/app/(routes)/products/[id]/error.tsx");
